import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from "reactstrap";
import FormDialog from './SubscritionModals/FreeAccount';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { DemoMap } from '../About/DemoMap';
import aboutimg from '../../../Assets/Images/about-us.png';
import tickmark from '../../../Assets/Images/tickmark.png';
import reportfrontcover from '../../../Assets/Images/reportfront-cover.png';
import crossmark from '../../../Assets/Images/cross.png';
import { Link } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import rvparklqbrochure from '../../../Assets/Images/rvparklq-brochure.png';
import demomapimage from '../../../Assets/Images/map-view.png';
import HubspotForm from 'react-hubspot-form';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import ConstantData from '../../../Utils/Constant';
import {HubSpotForm } from '../../../helpers/componentHelper';
const Pricing = (props) => {
    const [openChild, setChildOpen] = useState(false);
    const [choosenPackage] = useState('');
    const [isLoading] = useState(false);
    const priceDetails = props.packageFullData ? props.packageFullData : null;
    const [plan, setPlan] = useState("annually");
    const [proPrice,setProPrice] = useState("")
    const [contactUsOpen, setContactUsOpen] = useState(false);
    const navigate = useNavigate();
    // closeChild
    const closeChild = useCallback(
        (show) => {
            setChildOpen(show);
        },
        [openChild]
    );

    useEffect(() => {
        if (priceDetails?.length > 0) {
            const { currency, price } = priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.annually)[0];
            setProPrice(currency + Math.floor(price / 12));
        } else {
            setProPrice("");
        }
    }, [priceDetails]);
    
    const handleToggleChange = (event, newPlan) => {
        if (newPlan !== null) {
            setPlan(newPlan);
            if (priceDetails && priceDetails.length > 0) {
                const id = ConstantData.lookupKeyMap[newPlan];
                const divide = newPlan === "quarterly" ? 3 : 12;
                const { currency, price } = priceDetails.filter(data=>data.id === id)[0];
                setProPrice(currency + Math.floor(price / divide));
            }
        }
    };
    const CallChildOpen = (data) => {
        navigate("/account-subscription?type=" + data);
    }

    const onePrepaidPrice = priceDetails && priceDetails.length > 0 ? priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0].currency + priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0].price : null;
    const fivePrepaidPrice = priceDetails && priceDetails.length > 0 ? priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.fiveReport)[0].currency + priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.fiveReport)[0].price : null;
    const tenPrepaidPrice = priceDetails && priceDetails.length > 0 ? priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.tenReport)[0].currency + priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.tenReport)[0].price : null;
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
      };
      const faqData = [
        {
          question: 'What is a Market?',
          answer: 'A market is defined as a 10 to 100 mile radius around an address or location of an RV Park or Campground. Any data shown will be based on the radius you select.',
          panel: 'panel1'
        },
        {
          question: 'I only need one report, do I need to subscribe?',
          answer: 'No, you can purchase a single report for $109. You can also sign up for a free account to explore the product with limited information before purchasing a market report',
          panel: 'panel2'
        },
        {
          question: 'I want to look up markets in different regions, what is my best option?',
          answer: 'You can search for markets anywhere with a FREE account. This will give you a snapshot of the market with limited data. You can upgrade to an PRO Explorer account to unlock additional data or purchase a full, on demand Market Report for a deeper, detailed market analysis.',
          panel: 'panel3'
        },
        {
          question: 'Do you offer special offers or discounts?',
          answer: 'Contact our sales team to discuss enterprise-level accounts or if you have any questions about the options presented above.',
          panel: 'panel4'
        }
      ];
    return (
        <div className='body-content'>
            {isLoading ? (
                <div className="loader-wrap">
                    <div className="default-page loading loading-center"></div>
                </div>
            ) : (
                ""
            )}
            <div className='about-us pt-5 pb-5 mb-4 about-section' id='about-us'>
                <Container>
                    <Row>
                        <Col md={12} lg={5} className='about-content'>
                            <div>
                                <h1>Instant Market <br/>Insights for RV Parks <br/>& Campgrounds</h1>
                                <p> Make informed investment decisions with Explorer, our interactive mapping and market data platform. Evaluate properties, run reports, and perform due diligence on any US site. Start exploring now!</p>
                                {/* <Link to={"/account-subscription?type=free"} className='market-btn'>Try it for Free</Link>
                                <a href="#pricing-details" className='border-btn'>Pricing</a> */}
                                <div className='two-btn'>
                                <Link to={"/account-subscription?type=free"} className='signfree singcolor'>Sign Up for Free</Link>
                                <Link to={"/bookademo"} className='signfree signfree bookcolor'>Book a Demo</Link>
                                {/* <a href="#" className='border-btn signfree singcolor'>Sign Up for Free</a> */}
                                {/* <a href="#" className='border-btn '> Sign Up for Free</a> */}
                            </div>
                            </div>
                            
                        </Col>
                        {/* <Col md={7} className="text-center">
                            <img src={aboutimg} />
                        </Col> */}
                    </Row>
                </Container>
            </div>
            <div className='mb-3 pb-2'>
            <Container>
                <h3 className='text-center pb-3'>Check out the interactive Market Explorer demo!</h3>
                {/* <DemoMap /> */}
                <img src={demomapimage} alt="" style={{maxWidth: '100%', marginBottom: '15px'}}/>
                </Container>
            </div>
            <div className='pricing-content pt-4 pb-5' id="pricing-details">
                <Container>
                    <h3 className='choose'>Choose the plan that is right for you</h3>
                    <p className='para-desc'>Market Explorer lets you examine the supply and demand sides of the RV Parks and Campground Industry. Using our proprietary scoring, you can view, on average, how many people are willing to go camping. You will also get a complete market dynamic picture by analyzing the RV Park Profiles of the competition and the Demographics of any given market.</p>
                    <div className='feature-matrix'>
                        <div className="m-0 row">                            
                            <div className="other-columns-right free-col col-sm-3 col-md-3">
                                <div className="price-pack">
                                    <h3>Free</h3>
                                </div>
                                <a
                                    onClick={() => CallChildOpen('free')}
                                    className='create-acc-btn border-btn'>
                                    Sign Up Now!
                                </a>
                                <h4 className='subline-heading'>RV Park Profile</h4>
                                <ul>
                                    <li><img src={tickmark} alt="Tick Icon" /> Property Address</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Property Details</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Amenities and Features</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Rate Details</li>
                                    {/* <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Marketing</li> */}
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Ownership</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Debt</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Transaction History</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Seasonality</li>
                                </ul>
                                <h4>Population Profile</h4>
                                <ul>                                    
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> RV Parks in the Market</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Average price per night</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Average size of park</li>
                                    {/* <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Rental Availability</li> */}
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Population</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Population Density</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Region Type</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Income per Capita</li>
                                    {/* <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Average Fuel Cost</li> */}
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Population by Age</li>
                                    {/* <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Population by Ethnicity</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Population by Gender</li> */}
                                </ul>
                                <h4>Market Demand Analysis</h4>
                                <ul>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Market Demand Score</li>
                                    <li className='cross-mark'><img src={crossmark} alt="Tick Icon" /> Market Supply Factors</li>
                                </ul>
                            </div>
                            <div className="other-columns-right highlight col-sm-3 col-md-3">
                                <div className={`price-pack ${plan==="quarterly"?"price-pack-quarterly":""}`}>
                                    <h3>PRO</h3>
                                  {plan==="annually"&&(<p>
                                        <b>{proPrice}</b>/{priceDetails && priceDetails.length > 0 ? 'Month' : ''}
                                    </p>)}
                                    <div className={`price-info ${plan==="quarterly"?"price-info-quarterly":""}`}>with an <ToggleButtonGroup
                                     value={plan}
                                      exclusive
                                       onChange={handleToggleChange}
                                        sx={{
                                             backgroundColor: "#fff",
                                             borderRadius: "20px",
                                              padding: "2px",
                                               }}>
                                                 <ToggleButton
                                                 value="annually"
                                                   sx={{
                                                     textTransform: "none",
                                                      border: "none",
                                                       "&.Mui-selected": {
                                                        backgroundColor: "#f15d47",
                                                        color: "white",
                                                        "&:hover": { backgroundColor: "#f15d47" },
                                                         },
                                                         }}>
                                                         Annually
                                                         </ToggleButton>
                                                          <ToggleButton
                                                          value="quarterly"
                                                            sx={{
                                                                textTransform: "none",
                                                                border: "none",
                                                                "&.Mui-selected": {
                                                                    backgroundColor: "#f15d47",
                                                                    color: "white",
                                                                     "&:hover": { backgroundColor: "#f15d47" },
                                                                       },
                                                                        }}  >
                                                                         Quarterly
                                                                          </ToggleButton>
                                                                          </ToggleButtonGroup>
                                                                           subscription</div>
                                                                           </div>
                                                                           <button onClick={() => {
                                                                            if (plan === "quarterly") {
                                                                                setContactUsOpen(true);
                                                                                } else {
                                                                                    CallChildOpen(`unlimited-${plan}`);}}}
                                                                                    className="create-acc-btn border-btn">
                                                                                    {plan === "quarterly" ? "Contact us" : "Subscribe"}
                                                                                    </button>
                                                                                    <HubSpotForm contactUsOpen={contactUsOpen} setContactUsOpen={setContactUsOpen}/>
                                                                                   
                                <h4 className='subline-heading'>RV Park Profile</h4>
                                <ul>
                                    <li><img src={tickmark} alt="Tick Icon" /> Property Address</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Property Details</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Amenities and Features</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Rate Details</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Marketing</li> */}
                                    <li><img src={tickmark} alt="Tick Icon" /> Ownership</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Debt</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Transaction History</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Seasonality</li>
                                </ul>
                                <h4>Population Profile</h4>
                                <ul>
                                    <li><img src={tickmark} alt="Tick Icon" /> RV Parks in the Market</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Average price per night</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Average size of park</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Rental Availability</li> */}
                                    <li><img src={tickmark} alt="Tick Icon" /> Population</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Population Density</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Region Type</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Income per Capita</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Average Fuel Cost</li> */}
                                    <li><img src={tickmark} alt="Tick Icon" /> Population by Age</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Population by Ethnicity</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Population by Gender</li> */}
                                </ul>
                                <h4>Market Demand Analysis</h4>
                                <ul>
                                    <li><img src={tickmark} alt="Tick Icon" /> Market Demand Score</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Market Supply Factors</li>
                                </ul>
                            </div>
                            <div className="other-columns-right col-sm-3 col-md-3 last-column">
                                <div className="price-pack">
                                    <h3>Market Reports</h3>
                                    <p>Purchase for <b>{onePrepaidPrice}</b>/market</p>
                                    <Link to="/preview-market" className='create-acc-btn preview-data'>Preview Data Before Buying</Link>
                                </div>
                                <button onClick={() => CallChildOpen('single-prepaid-report')} className='create-acc-btn border-btn mb-2'>Buy Single Market</button>
                                <div style={{display: 'flex', gap: '5px'}}>
                                <button onClick={() => CallChildOpen('five-prepaid-report')} className='create-acc-btn border-btn mb-2 light-green-btn'>Buy 5 Markets @ <b>{fivePrepaidPrice}</b></button>
                                <button onClick={() => CallChildOpen('ten-prepaid-report')} className='create-acc-btn border-btn mb-2 light-green-btn'>Buy 10 Markets @ <b>{tenPrepaidPrice}</b></button>
                                </div>
                                <h4 className="subline-heading">RV Park Profile</h4>
                                <ul>
                                <li><img src={tickmark} alt="Tick Icon" /> Property Address</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Property Details</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Amenities and Features</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Rate Details</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Marketing</li> */}
                                    <li><img src={tickmark} alt="Tick Icon" /> Ownership</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Debt</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Transaction History</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Seasonality</li>
                                </ul>
                                <h4>Population Profile</h4>
                                <ul>
                                <li><img src={tickmark} alt="Tick Icon" /> RV Parks in the Market</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Average price per night</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Average size of park</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Rental Availability</li> */}
                                    <li><img src={tickmark} alt="Tick Icon" /> Population</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Population Density</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Region Type</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Income per Capita</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Average Fuel Cost</li> */}
                                    <li><img src={tickmark} alt="Tick Icon" /> Population by Age</li>
                                    {/* <li><img src={tickmark} alt="Tick Icon" /> Population by Ethnicity</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Population by Gender</li> */}
                                </ul>
                                <h4>Market Demand Analysis</h4>
                                <ul>
                                <li><img src={tickmark} alt="Tick Icon" /> Market Demand Score</li>
                                    <li><img src={tickmark} alt="Tick Icon" /> Market Supply Factors</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
                 <Container className='marketreportnew-section'>
                    <Row>
                    <Col lg={6} xs={12}>
                    <div  className='marketreportnew-content'> 
                        <h4>Market Reports: Preview any market before evaluating it further</h4>
                        <p className='marketreportnew-content-p'>Dive deeper into any market with a PDF report from Market Explorer, plus 30-day platform access for further analysis. Reports cover RV park profiles, amenities, market demand, supply factors, and more!</p>
                       <div className='prvmkt-btn'><a href="/preview-market" className='border-btn signfree previewmrt '>Preview Market</a></div> 
                    </div>
                        
                    </Col> 
                    <Col lg={6} xs={12}>
                        <div className='reportcover'> <img src={reportfrontcover} alt="reportfrontcovern" /> </div>
                        
                    </Col> 
                    </Row>
                    
                </Container>        
            {openChild ? <FormDialog openChild={openChild} closeChild={closeChild} choosenPackage={choosenPackage} /> : ''}
            
            <Container> 
            <Row>
               
            <div className='freqty-qust'>
            <h2 >Frequently Asked Questions</h2>
      {faqData.map((faq) => (
        <Accordion key={faq.panel} expanded={expanded === faq.panel} onChange={handleChange(faq.panel)}>
          <AccordionSummary
            expandIcon={expanded === faq.panel ? <RemoveIcon /> : <AddIcon />}
            aria-controls={`${faq.panel}-content`}
            id={`${faq.panel}-header`}
          >
            <Typography className='faq-headtitle'>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className='faq-prag'>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
    </Row>
    </Container> 
    <Container className='formboder'> 
        
        <Row>
            
        <Col lg={6} xs={12} className='rv-brochure'> 
        <div className='from-leftside'>
        <img src={rvparklqbrochure} alt="rvparklqbrochure"/>
        </div>
        </Col>
        <Col lg={6} xs={12} >
            <div className='form-rightside'>
                <h2>Free Download: <br/> Explore Our Solutions</h2>
                <div className="reactHubspotForms-brochure">
                  <HubspotForm
                    portalId='4297816'
                    formId='1c58eb25-012f-485b-a9e1-cffa04700dff'
                    cssClass="hub-spot-brochure"
                    css=""
                  />
                </div>
                
            </div>
        </Col>

        </Row>

    </Container>
            
        </div>

    );
}

export default Pricing;